<!--红包按钮-->
<template>
  <div class="red-pack-page">
    <van-floating-bubble v-if="show && showIcon" class="red-pack" v-model:offset="offset" :gap="0" axis="xy" teleport="">
      <div class="red-icon" ref="iconDOM" @click="redpack.setShow(true)"></div>
    </van-floating-bubble>
    <!--红包弹窗-->
    <van-popup class="redmain-pop" v-model:show="redpack.show" round @closed="redpack.setClosed(false)">
      <RedMain v-if="redpack.isclosed" @close="redpack.setShow" />
    </van-popup>
  </div>
</template>

<script lang="ts">
import {defineComponent, nextTick, onMounted, reactive, ref} from 'vue';
import { FloatingBubble } from 'vant';
import { useRect } from '@vant/use';
import RedMain from "/@/layout/child-page/RedMain.vue";

export default defineComponent({
  name: "RedPack",
  components: {[FloatingBubble.name]: FloatingBubble, RedMain,},
  props: {
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const offset = ref({ x: 0, y: 0 });
    const iconDOM = ref(null);
    const show = ref(true);
    // 红包弹窗数据
    const redpack = reactive({
      show: false,
      isclosed: false, // 关闭弹窗后销毁子组件
      setShow: (bool = true) => {
        redpack.show = bool;
        bool && redpack.setClosed(bool);
      },
      setClosed: (bool = false) => {
        redpack.isclosed = bool
      }
    });
    // 初始化按钮位置
    const initDot = () => {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      let rect = useRect(iconDOM); // 图标的宽高
      // 定义位置
      offset.value.x = Math.floor(width - rect.width);
      offset.value.y = Math.floor(height - rect.height - 150); // 下方有客服按所以多减点
      show.value = false;
      nextTick(()=> {
        show.value = true;
      });
    };
    onMounted(() => {
      iconDOM.value && initDot();
    });
    return {
      show,
      offset,
      iconDOM,
      redpack,
    };
  },
})
</script>

<style scoped lang="scss">
.red-pack-page {
  width: 0;
  height: 0;
  .red-pack {
    width: 80px;
    height: 86px;
    background: none;
    overflow: visible;

    &:active {
      opacity: 1;
    }
    .red-icon {
      width: 100%;
      height: 100%;
      background: url(publicImgUrl('hongbao/red_pack_icon.png')) center center / contain no-repeat;
    }
  }
  // 红包弹窗
  .redmain-pop {
    width: px2rem(350);
    height: px2rem(490);
    background: none;
    overflow: visible;
    @include flexStyle();
  }
}

// 主题
.themeKYMN {
  .red-pack-page {
    .red-pack {
      .red-icon {
        background-image: url(publicImgUrl('hongbao/red_pack_icon1.png'));
      }
    }
  }
}
</style>